(() => {
  if (window.__yoCollectionVariantAvailabilityInstalled) return;
  window.__yoCollectionVariantAvailabilityInstalled = true;

  const CARD_SELECTOR = '.spf-product-card';
  const SWATCH_SELECTOR = '.spf-product__swatch[data-option]';
  // This catalogue uses option 1 for Color, followed by Size.
  const COLOR_OPTION_ORDER = '1';
  const VARIANT_SELECTOR = 'select.spf-product__variants option';

  // Scoped to the 72 approved previous-Winter49 collection members.
  const WINTER49_SCOPE = new Set(["9087786189013", "9087786778837", "9153386807509", "9087786909909", "9153386447061", "9087786483925", "9153386512597", "9087786582229", "9060336402645", "9153386971349", "9087786287317", "9060336337109", "9153386840277", "9060336107733", "9087786352853", "9060340564181", "9089605271765", "9089609793749", "9060335616213", "9153392640213", "9075292405973", "9087786680533", "9060335780053", "9087786549461", "9060335321301", "9089610711253", "9060336074965", "9060335190229", "9087786942677", "9060335878357", "9060335648981", "9087786844373", "9060335550677", "9153248788693", "9153248919765", "9089607270613", "9089606025429", "9087785959637", "9153248002261", "9153248624853", "9153248821461", "9060336173269", "9153249116373", "9153386348757", "9153386709205", "9060336140501", "9075295682773", "9087786418389", "9060336304341", "9075296665813", "9060335386837", "9060336042197", "9075290996949", "9089605632213", "9075297026261", "9106059428053", "9060335222997", "9060335485141", "9060335911125", "9060335845589", "9060335517909", "9060335419605", "9060335452373", "9060336271573", "9060336206037", "9060336009429", "9060335943893", "9060335681749", "9060335583445", "9075293749461", "9075293946069", "9075294535893"]);
  const winter49OriginalDisplay = new WeakMap();
  const winter49SelectionPending = new WeakSet();
  function setWinter49Hidden(swatch, hidden) {
    if (hidden) {
      if (!winter49OriginalDisplay.has(swatch)) {
        winter49OriginalDisplay.set(swatch, { display: swatch.style.getPropertyValue("display"), priority: swatch.style.getPropertyPriority("display"), hidden: swatch.hidden });
      }
      swatch.hidden = true;
      swatch.style.setProperty("display", "none", "important");
      swatch.dataset.yoWinter49Hidden = "true";
    } else if (winter49OriginalDisplay.has(swatch)) {
      const prior = winter49OriginalDisplay.get(swatch);
      swatch.hidden = prior.hidden;
      if (prior.display) swatch.style.setProperty("display", prior.display, prior.priority);
      else swatch.style.removeProperty("display");
      delete swatch.dataset.yoWinter49Hidden;
      winter49OriginalDisplay.delete(swatch);
    }
  }

  function selectedValues(card) {
    const values = {};
    card.querySelectorAll(`${SWATCH_SELECTOR}.is-selected`).forEach((swatch) => {
      values[swatch.dataset.option] = swatch.dataset.optionValue;
    });
    return values;
  }

  function variantMatches(option, selected, optionOrder, optionValue) {
    if (option.getAttribute(`data-option${optionOrder}`) !== optionValue) return false;
    // A color is sold out only when NO size of that color is available.
    // Size availability still depends on the currently selected color.
    if (optionOrder === COLOR_OPTION_ORDER) return true;
    return Object.entries(selected).every(([order, value]) =>
      order === optionOrder || option.getAttribute(`data-option${order}`) === value
    );
  }

  function applyAvailability(card) {
    const variants = Array.from(card.querySelectorAll(VARIANT_SELECTOR));
    if (!variants.length) return;

    const selected = selectedValues(card);
    card.querySelectorAll(SWATCH_SELECTOR).forEach((swatch) => {
      const order = swatch.dataset.option;
      const value = swatch.dataset.optionValue;
      const available = variants.some((variant) =>
        variant.getAttribute('data-available') === 'true' &&
        variantMatches(variant, selected, order, value)
      );
      if (order === COLOR_OPTION_ORDER && WINTER49_SCOPE.has(card.dataset.laDnProductId)) {
        const sameColor = variants.filter((variant) => variant.getAttribute("data-option1") === value);
        // Missing or ambiguous data fails open.
        const hidden = sameColor.length > 0 && sameColor.every((variant) => variant.getAttribute("data-available") === "false");
        setWinter49Hidden(swatch, hidden);
        if (hidden && swatch.classList.contains("is-selected") && !winter49SelectionPending.has(card)) {
          const replacement = Array.from(card.querySelectorAll(SWATCH_SELECTOR)).find((other) =>
            other.dataset.option === COLOR_OPTION_ORDER && variants.some((variant) =>
              variant.getAttribute("data-available") === "true" && variant.getAttribute("data-option1") === other.dataset.optionValue));
          if (replacement) {
            winter49SelectionPending.add(card);
            window.requestAnimationFrame(() => {
              winter49SelectionPending.delete(card);
              if (card.isConnected && swatch.classList.contains("is-selected") && swatch.dataset.yoWinter49Hidden === "true") replacement.click();
            });
          }
        }
      }
      swatch.classList.toggle('soldout', !available);
      const disabled = String(!available);
      if (swatch.getAttribute('aria-disabled') !== disabled) {
        swatch.setAttribute('aria-disabled', disabled);
      }
    });
  }

  function applyWithin(root) {
    if (!(root instanceof Element) && root !== document) return;
    if (root.matches?.(CARD_SELECTOR)) applyAvailability(root);
    root.querySelectorAll?.(CARD_SELECTOR).forEach(applyAvailability);
  }

  function scheduleCard(card) {
    if (!card) return;
    window.requestAnimationFrame(() => applyAvailability(card));
    window.setTimeout(() => applyAvailability(card), 80);
  }

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest?.(SWATCH_SELECTOR);
    if (swatch) scheduleCard(swatch.closest(CARD_SELECTOR));
  });

  // Globo can update soldout/is-selected after click handlers and after
  // filtering/pagination. Reconcile those changes, not just newly added cards.
  const pendingCards = new Set();
  let pendingFrame = 0;
  function queueCard(card) {
    if (!card) return;
    pendingCards.add(card);
    if (pendingFrame) return;
    pendingFrame = window.requestAnimationFrame(() => {
      pendingFrame = 0;
      const cards = Array.from(pendingCards);
      pendingCards.clear();
      cards.forEach((card) => { if (card.isConnected) applyAvailability(card); });
    });
  }

  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'attributes') {
        if (record.target.matches(SWATCH_SELECTOR) || record.target.matches(VARIANT_SELECTOR)) {
          queueCard(record.target.closest(CARD_SELECTOR));
        }
      } else {
        record.addedNodes.forEach((node) => applyWithin(node));
      }
    });
  });

  function start() {
    applyWithin(document);
    observer.observe(document.body, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['class', 'data-available']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.YaelCollectionVariantAvailability = { applyAvailability };
})();
